/**
 * External widgets loader
 *
 * Created by:
 *     Nikita Svesnikov <niko@1stdibs.com>
 *
 * Description:
 *     Widget loader is used to load externals widgets dynamically within
 *     any javascript module. Adds script tags to head, and when it is ready resolves
 *     a promise, to make sure widget is loaded and ready to be used.
 *     When widget is loaded at first time, it is cached, and resolved without adding new
 *     script tags to head at any further load request.
 *
 * Usage:
 *     const widgetLoader = require('global/widgets/widgetLoader');
 *
 *     widgetLoader
 *         .load('pinterest')
 *         .then(pinterest => {
 *             // widget is loaded and ready to be used
 *             pinterest.setSession('whatever-session');
 *         })
 *         .catch(() => {});
 */

'use strict';

const SV = require('server-vars');
const ScriptInjector = require('../utils/ScriptInjector');

const getEnvAccount = function (accounts) {
    const env = SV.get('settings.environment');
    return accounts[env] || accounts.development;
};

const scripts = {
    pinterest() {
        return ScriptInjector
            .inject('https://assets.pinterest.com/sdk/sdk.js')
            .then(() => {
                return global.PDK;
            });
    },

    intercom() {
        const accounts = {
            production: 'fnj80w14',
            development: 'j06umpub'
        };

        const account = getEnvAccount(accounts);

        return ScriptInjector
            .inject(`https://widget.intercom.io/widget/${account}`)
            .then(() => {
                const intercom = global.Intercom;
                intercom('boot', {
                    'app_id': account
                });

                return intercom;
            });
    }
};

const getters = {
    // At some point Intercom mutates global variable,
    // so we should always return global.Intercom
    intercom() {
        return Promise.resolve(global.Intercom);
    }
};

/**
 * Scripts loader. Also it caches loading promise to load script once.
 * @param  {String} type script provider
 * @return {Promise}
 */
const load = function (type) {
    const loader = load[type];
    const getter = getters[type];

    if (loader && getter) {
        return loader.then(() => getter());
    } else if (loader) {
        return loader;
    }

    if (!scripts[type]) {
        throw new Error('Widget script for ' + type + ' is not provided.');
    }

    load[type] = typeof scripts[type] === 'function' ?
        scripts[type]() :
        ScriptInjector.inject(scripts[type]);

    return load[type];
};

module.exports = { load };



// WEBPACK FOOTER //
// ./assets/js/global/widgets/widgetLoader.es.js